var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBold1Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 5H14.3333C15.3058 5 16.2384 5.36875 16.9261 6.02513C17.6137 6.6815 18 7.57174 18 8.5C18 9.42826 17.6137 10.3185 16.9261 10.9749C16.2384 11.6313 15.3058 12 14.3333 12H7V5Z",
    stroke: "#707C89",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12H14.6154C15.513 12 16.3739 12.3687 17.0087 13.0251C17.6434 13.6815 18 14.5717 18 15.5C18 16.4283 17.6434 17.3185 17.0087 17.9749C16.3739 18.6313 15.513 19 14.6154 19H7V12Z",
    stroke: "#707C89",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold1Icon);
export default __webpack_public_path__ + "static/media/bold-1-icon.9bdacd1a20f5ef9826b0e82cc3b237be.svg";
export { ForwardRef as ReactComponent };